module.exports = __webpack_public_path__ + "static/media/retail-square.40bbcac4.jpg";